import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useCareCreditDisconnectProvider } from '@frontend/payments-care-credit';
import { theme } from '@frontend/theme';
import { Button, Chip, useAlert, useModalControl } from '@frontend/design-system';
import CareCreditIcon from '../assets/care-credit-logo.svg?react';
import { DisconnectProviderModal } from './disconnect-provider-modal';

export type LocationConnectedSettingsProps = {
  locationId: string | undefined;
};
export const LocationConnectedSettings = ({ locationId }: LocationConnectedSettingsProps) => {
  const { t } = useTranslation('payments');
  const alerts = useAlert();

  const { onDisconnectMutation, isMutating } = useCareCreditDisconnectProvider({ locationId });

  const onClickDisconnect = useCallback(async () => {
    if (isMutating) return;

    await onDisconnectMutation();
    alerts.success(t('CareCredit account disconnected successfully'));
  }, [isMutating, onDisconnectMutation]);

  const { triggerProps, modalProps } = useModalControl();

  return (
    <div
      className='location-connected-settings'
      css={{
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div
        className='left'
        css={{
          display: 'flex',
          gap: theme.spacing(1),
          alignItems: 'center',
        }}
      >
        <div>
          <CareCreditIcon />
        </div>
        <div>
          <Chip variant='success'>{t('Connected')}</Chip>
        </div>
      </div>

      <div className='right'>
        <Button {...triggerProps} variant='tertiary' destructive loading={isMutating}>
          {t('Disconnect Account')}
        </Button>
      </div>
      <DisconnectProviderModal modalProps={modalProps} isMutating={isMutating} onSubmit={onClickDisconnect} />
    </div>
  );
};
